(function(){
  /* ---- (2) Finish detail popup: reflect sold-out when a sold-out finish is opened ---- */
  /* The configurator's loupe handler calls stopPropagation() on bubble, so we read the swatch
     state in the CAPTURE phase, then patch the popup on the next frame (after openColor has run
     and created/opened .wv-cpop). */
  document.addEventListener('click', function(e){
    var z = e.target.closest && e.target.closest('.wv-finsw .wv-finzoom');
    if (!z) return;
    var sw = z.closest('.wv-finsw');
    var sold = !!(sw && sw.classList.contains('is-soldout'));
    requestAnimationFrame(function(){
      var av = document.querySelector('.wv-cpop .wv-cpop-avail');
      if (!av) return;
      if (sold){ av.textContent = 'Sold out'; av.classList.add('wv-cpop-avail--oos'); }
      else { av.textContent = 'Available now'; av.classList.remove('wv-cpop-avail--oos'); }
    });
  }, true);
})();
